export enum UnitType {
  Numeric = 1,
  Time = 2,
  Text = 3, // Not summable type
  Percentage = 4,
  Gigajoule = 5,
  Empty = 23 // Not summable type
}

export enum PlantStructureFilterOptions {
  All = 'all',
  PlannerStorages = 'plannerStorages',
  PlannerAssets = 'plannerAssets',
  Janus = 'janus',
  Removed = 'removed'
}

export enum UpmMappingTypes {
  Plant = 1,
  Area = 2,
  Department = 3,
  Equipment = 4
}
